import * as yup from 'yup';
import moment from 'moment';
import GenericField from '@shared/fields/generic-field';
import { i18n } from '@shared/i18n';

export default class DateModelField extends GenericField {
  constructor(name, label, { 
    required = false, 
    onlyPastDate = false, 
    minAge = null, 
    dateFormat = 'MM/dd/yyyy', 
    populateDate = { year: true, month: true, day: true}, 
  } = {}) {
    super(name, label);
    this.required = required;
    this.onlyPastDate = onlyPastDate;
    this.minAge = minAge;
    this.dateFormat = dateFormat ? dateFormat.toUpperCase() : 'MM/dd/yyyy';
    this.populateDate = populateDate ? populateDate : { year: true, month: true, day: true};
  }

  forPresenter(value) {
    if (!value || !Object.keys(value).length) return undefined;
    
    const { year: yearPopulate, month: monthṔopulate, day: dayPopulate } = this.populateDate;
    var dateFormatToUpdate = this.dateFormat;
    
    if (!yearPopulate) dateFormatToUpdate = dateFormatToUpdate.replace('yyyy','');
    if (!monthṔopulate) dateFormatToUpdate = dateFormatToUpdate.replace('MM','');
    if (!dayPopulate) dateFormatToUpdate = dateFormatToUpdate.replace('DD','');
    
    dateFormatToUpdate = dateFormatToUpdate.replace(/[/]+/, '/');
    dateFormatToUpdate = dateFormatToUpdate.replace(/[/]+$/, '');
    dateFormatToUpdate = dateFormatToUpdate.replace(/^[/]+/, '');
    
    var { year, month, day } = value;

    year = year ? year : 0
    month = month ? month - 1 : 0
    day = day ? day : 0

    return moment().date(day).month(month).year(year).format(dateFormatToUpdate);
  }

  forFormInitialValue(value) {
    if (!value || !Object.keys(value).length) return undefined;
    var { year, month, day } = value;

    year = year ? year : 0
    month = month ? month - 1 : 0
    day = day ? day : 0

    return moment().date(day).month(month).year(year);
  }

  forFilterInitialValue() {
    return undefined;
  }

  forFilterRules() {
    return undefined;
  }

  forFilterCast() {
    let yupChain = yup
    .mixed()
    .nullable(true)
    .label(this.label)
    .transform((value) => {
      if (!value) return undefined;

      const dt = moment(value);
      return {
        day: dt.date(),
        month: dt.month() + 1,
        year: dt.year()
      };
    });

    return yupChain;
  }

  forFormRules() {
    const output = [];

    if (this.required) {
      output.push({
        required: !!this.required,
        message: i18n('validation.mixed.required').replace(
          '${path}',
          this.label,
        ),
      });
    }

    if (this.onlyPastDate) {
      output.push({
        validator: (rule, value, callback) => {
          const errorMessage = i18n('validation.date.mustBePast').replace('${path}', this.label);
          const now = +new Date;
          if (value > now) callback(new Error(errorMessage));
          else callback();
        }
      });
    }

    if (this.minAge) {
      output.push({
        validator: (rule, value, callback) => {
          const errorMessage = i18n('validation.date.minAge').replace('${age}', this.minAge);
          const age = moment().diff(value, 'years');
          if (age < this.minAge) callback(new Error(errorMessage));
          else callback();
        }
      });
    }

    return output;
  }

  forFormCast() {
    let yupChain = yup
      .mixed()
      .nullable(true)
      .label(this.label)
      .transform((value) => {
        if (!value) return undefined;

        const dt = moment(value);
        return {
          day: dt.date(),
          month: dt.month() + 1,
          year: dt.year()
        };
      });

    return yupChain;
  }
}
// ^.+\/